<div fxFlex="34" class="sideImage" #sideimage>
  <img src="assets/images/backgrounds/request_data.jpg" alt="">
</div>
<ng-container *ngFor="let requirement of modelService.lead.requirements">
  <div fxFlex="66" class="requestData" *ngIf="detailGathering" fxLayout="row wrap">

    <div class="infoSet" [class.slideOutFromLeft]="slideOut" fxFlex="100" fxLayout="row wrap">
      <div class="head" fxFlex="100">
        <h5>Commercials</h5>
      </div>
      <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Pick-up Charge/cont.</span>
          </div>
          <app-new-money-field [(amount)]="model.pickup_charge" [(currency)]="model.pickup_charge_currency"
            [isEditable]="true"></app-new-money-field>
        </div>

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Payee</span>
          </div>
          <mat-button-toggle-group name="Payee" [(ngModel)]="model.payee" class="payee">
            <mat-button-toggle value="arcon">Arcon pays</mat-button-toggle>
            <mat-button-toggle value="customer" *ngIf="modelService.lead.transaction_type=='use'">
              User pays
            </mat-button-toggle>
            <mat-button-toggle value="supplier" *ngIf="modelService.lead.transaction_type=='supply'">
              Supplier pays
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Free Days/Max usage</span>
          </div>
          <div class="perVal">
            <div fxLayout="row">
              <div fxFlex="50" fxLayout="row">
                <input matInput [(ngModel)]="model.min_free_days" type="number" name="min_free_days" placeholder="Min">|
              </div>
              <div fxFlex="50">
                <input matInput [(ngModel)]="model.max_free_days" type="number" name="max_free_days" placeholder="Max">
              </div>
            </div>
          </div>
        </div>

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Per Diem/cont. (in USD)</span>
          </div>
          <div class="perVal">
            <div fxLayout="row">
              <div fxFlex="50" fxLayout="row">
                <input matInput [(ngModel)]="model.min_per_diem" type="number" name="min_per_diem" placeholder="Min">|
              </div>
              <div fxFlex="50">
                <input matInput [(ngModel)]="model.max_per_diem" type="number" name="max_per_diem" placeholder="Max">
                <!-- <mat-select [(value)]="selectedCurrency">
                      <mat-option [value]="option.value" *ngFor="let option of currencys">
                          {{option.viewValue }}</mat-option>
                  </mat-select> -->
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="modelService.lead.transaction_type=='supply'">
          <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
            <div class="inputTitle">
              <span>DPP/cont.</span>
            </div>
            <app-new-money-field [(amount)]="model.dpp_charge" [(currency)]="model.dpp_charge_currency"
              [isEditable]="true"></app-new-money-field>
          </div>
        </ng-container>

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Storage Charge/cont.</span>
          </div>
          <app-new-money-field [(amount)]="model.storage_charge" [(currency)]="model.storage_charge_currency"
            [isEditable]="true"></app-new-money-field>
        </div>

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Drop-off Fee/cont.</span>
          </div>
          <app-new-money-field [(amount)]="model.dropoff_charge" [(currency)]="model.dropoff_charge_currency"
            [isEditable]="true"></app-new-money-field>
        </div>

        <ng-container *ngIf="modelService.lead.transaction_type=='supply'">
          <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
            <div class="inputTitle">
              <span>Cancellation Fee/cont.</span>
            </div>
            <app-new-money-field [(amount)]="model.cancellation_charge"
              [(currency)]="model.cancellation_charge_currency" [isEditable]="true"></app-new-money-field>
          </div>
        </ng-container>

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Insurance</span>
          </div>
          <app-mat-auto-search [(ngModel)]="model.insurance" [isEditable]="true" [idField]="null" displayField='name'
            [listUrl]="insuranceUrl" [labelItemTemplate]="insuranceSelectedItem" [itemTemplate]="insuranceItem">
          </app-mat-auto-search>
        </div>

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Remarks</span>
          </div>
          <app-text-field [(ngModel)]="model.remarks" [isEditable]="true" [isMultiline]="true"></app-text-field>
        </div>
      </div>
    </div>
    <ng-container *ngIf="modelService.lead.transaction_type=='supply'">
      <div class="infoSet" [class.slideOutFromLeft]="slideOut" fxFlex="100" fxLayout="row wrap">
        <div class="head" fxFlex="100">
          <h5>DRV Declaration/cont.</h5>
        </div>
        <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
          <app-new-money-field [(amount)]="model.drv_new_build_price" [(currency)]="model.drv_new_build_price_currency"
            [isEditable]="true" label="New Build Price" fxFlex="100" fxFlex.gt-xs="13.8em"
            fxLayout="column"></app-new-money-field>

          <app-percent-field [(ngModel)]="model.drv_depreciation_per_year" [isEditable]="true" label="Depreciation Per Year"
            class="align-items-center percent" fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column"></app-percent-field>

          <app-percent-field [(ngModel)]="model.drv_max_depreciation_percent" [isEditable]="true" label="Discounted Residual Value"
            class="align-items-center percent" fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column"></app-percent-field>
        </div>
      </div>
    </ng-container>
    <div class="tnc" [class.slideOutFromLeft]="slideOut" fxFlex="100">
      <mat-checkbox color="primary" [(ngModel)]="checked">I've read the <i> terms and conditions</i> and abide by the
        platform's data rules.
      </mat-checkbox>
    </div>
    <div class="btn2" [class.slideOutFromLeft]="slideOut" fxFlex="100" fxLayout="row">
      <button mat-raised-button class="Cancel" (click)="skip()">Skip</button>

      <button mat-raised-button class="Save" (click)="navigateToOrdersPage(requirement)"
        [disabled]="!checked || savingCommercials">Proceed</button>

    </div>

  </div>
</ng-container>
<div fxFlex="66" *ngIf="!detailGathering" fxLayout="column wrap" class="confirmation" #confirmation>
  <!--  <ng-container *ngIf="celebrate">-->
  <!--    <ng-particles id="tsparticles" [options]="rain" [particlesInit]="particlesInit">-->
  <!--    </ng-particles>-->
  <!--  </ng-container>-->
  <div class="confirmationData" [class.slideInFromLeft]="slideIn">
    <h5>Thank You!</h5>
    <span>
      Your request is submitted successfully. For future
      correspondence please keep Ref no:<mat-chip #requestNo class="fw-medium"
        [cdkCopyToClipboard]="modelService.lead.request_number" matTooltip="Click to copy" matTooltipPosition="right"
        selected color="primary">{{modelService.lead.request_number}}</mat-chip>
    </span>

  </div>

  <!-- <button mat-raised-button class="homebtn Save" [class.slideInFromLeft]="slideIn" (click)="navigateToQuotation()">Add
    expected rates</button> -->
  <button mat-raised-button class="homebtn Save" [class.slideInFromLeft]="slideIn" (click)="skip()">View request
    list</button>
  <!-- <button mat-raised-button class="homebtn Save" [class.slideInFromLeft]="slideIn" (click)="navigateToLogin()">Take me
    Home</button> -->

</div>


<ng-template #insuranceItem let-item let-index>
  <div fxLayout="column" class="m-t-8 m-b-8">
    <span class="insuranceName">
      {{item.name}}
    </span>
    <span class="insuranceRate">
      <ng-container *ngIf="item.amount!=null">
        {{item.amount_currency}} {{item.amount}}/{{item.amount_unit?.value}}
      </ng-container>
    </span>
    <!-- <span class="insuranceRate" *ngIf="item.amount_unit"> -->
    <!-- add include here -->
    <!-- </span> -->
  </div>
</ng-template>

<ng-template #insuranceSelectedItem let-item>
  {{item.name}}
</ng-template>